jQuery(function ($) {
    $('.fff-section__dropdownToggle').on('click', function () {
        $(this).siblings('.fff-section__dropdownContent').slideToggle();
    });
    $('.fff-section__dropdownClose').on('click', function () {
        $(this).parent().slideUp();
    });
    $('.dropdown-anchor-link').on('click', function () {
        let target = '#' + $(this).find('a').attr('href').substring(4);
        $(target).find('.fff-section__dropdownContent').slideDown();
    });
    let hash = window.location.hash;
    if (hash.length > 0) {
        let id = hash.substring(3);
        if ($('#' + id).length > 0) {
            $('#' + id).find('.fff-section__dropdownContent').slideDown();
        }
    }
    $('.fff-q').on('click', function () {
        $(this).toggleClass('-active');
        $(this).siblings('.fff-a').slideToggle();
    });
    $('.fff-productInfo__toggle').on('click', function () {
        $(this).toggleClass('-active');
        $(this).siblings('.fff-productInfo__content').slideToggle();
    });
    if ($('input#woocommerce_is_company').attr('checked')) {
        $('.fff-register__companyField').slideDown();
    }
    $('input#woocommerce_is_company').on('change', function () {
        $('.fff-register__companyField').slideToggle();
    });
});
jQuery(document).on('ready js_event_wpv_pagination_completed js_event_wpv_parametric_search_form_updated js_event_wpv_parametric_search_results_updated', function (event) {
    let $toggle = jQuery('.fff-productList__filtersToggle').find('button');
    let $filters = jQuery('.fff-productList__filters');
    if (event.type === 'ready') {
        $filters.css('display', 'none');
    }
    $toggle.off();
    $toggle.on('click', function (e) {
        e.preventDefault();
        $filters.slideToggle();
    });
});
